

export class User {
  icNo: string;
  nICNo: string;
  brNo: string;
  name: string;
  submittedBy: string;
  inputDate: string;
  accNo: string;
  lastEnqBy: string;
  dob: string;
  remark: string;
}



// WEBPACK FOOTER //
// ./src/app/users/shared/user.ts